import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout, Row, Col, Tabs } from 'antd';
import { Modal as ModalMobile } from 'antd-mobile';
import { withTranslation } from 'react-i18next';
import Format from '../../utils/format';
import OrderBackground from '../../assets/image/OrderBanner.png';
import IdleTimer from 'react-idle-timer';

const { Content } = Layout;
const { TabPane } = Tabs;
const confirmAlert = ModalMobile.alert;

@inject(
    'VersionStore',
    'templateStore',
    'loginStore',
    'webSettingStore',
    'TransactionStore'
)
@observer
class OrderPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login')
        }

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            }
        });

        this.props.templateStore.getActive();
        this.props.webSettingStore.getData();
        this.props.TransactionStore.get();

        this.myInterval = setInterval(() => {
            this.props.TransactionStore.get()
        }, 5000)
    }

    componentWillUnmount() {
        clearInterval(this.myInterval)
    }

    componentDidUpdate() {
        this.tabStyle();
    }

    tabStyle = () => {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        if (webSettting) {
            const tabs = document.getElementsByClassName('ant-tabs-tab');

            for (let i = 0; i < tabs.length; i++) {
                tabs[i].style.fontFamily = `${activeTemplate.templateSetting.tab.fontFamily}`;
                tabs[i].style.fontSize = `${activeTemplate.templateSetting.tab.fontSize}px`;
                tabs[i].style.lineHeight = `${activeTemplate.templateSetting.tab.fontSize + 2}px`;
                tabs[i].style.color = activeTemplate.templateSetting.tab.color;
            }

            const tabActives = document.getElementsByClassName('ant-tabs-tab-active');

            for (let i = 0; i < tabActives.length; i++) {
                tabActives[i].style.fontFamily = `${activeTemplate.templateSetting.tabSelected.fontFamily}`;
                tabActives[i].style.fontSize = `${activeTemplate.templateSetting.tabSelected.fontSize}px`;
                tabActives[i].style.lineHeight = `${activeTemplate.templateSetting.tabSelected.fontSize + 2}px`;
                tabActives[i].style.color = activeTemplate.templateSetting.tabSelected.color;
            }

            const tabInk = document.getElementsByClassName('ant-tabs-ink-bar');

            for (let i = 0; i < tabInk.length; i++) {
                tabInk[i].style.background = `${activeTemplate.templateSetting.tabSelected.color}`;
            }
        }
    }

    // ON CLICK

    orderClick = (order) => {
        this.props.TransactionStore.setOrderDetail(order);
        this.props.TransactionStore.setshowOrderDetailModal(true);
    }

    tabClick = (key) => {
        const tabId = key.toString();
        this.props.TransactionStore.setActiveTabId(tabId);
    }

    // ON RENDER

    showImageOnRender = (order) => {
        return (
            <React.Fragment>
                {
                    order.imageUrl === ''
                        ?
                        <img className='stm-item-image' src='https://via.placeholder.com/56' alt={order.taskName} />
                        :
                        <img className='stm-item-image' src={order.imageUrl} alt={order.taskName} />
                }
            </React.Fragment>
        )
    }

    // ON TOUCH

    _onTouchStart(e, that) {
        const touch = e.touches[0];
        that.props.TransactionStore.setSwipeX(touch.clientX);
        that.props.TransactionStore.setIsSwipe(false);
    }

    _onTouchMove(e, that) {
        if (e.changedTouches && e.changedTouches.length) {
            that.props.TransactionStore.setIsSwipe(true);
        }
    }

    _onTouchEnd(e, that, tabId) {
        const { swipeX, isSwipe, tabs } = that.props.TransactionStore;
        const touch = e.changedTouches[0];
        const absX = Math.abs(touch.clientX - swipeX);
        if (isSwipe && absX > 50) {
            if (touch.clientX - swipeX < 0) {
                let nextTabId = 0;
                for (let i = 0; i < tabs.length; i += 1) {
                    if (tabs[i].id === tabId) {
                        if (tabs[i + 1]) {
                            nextTabId = tabs[i + 1].id;
                            that.tabClick(nextTabId);
                        }
                        return;
                    }
                }
            } else {
                let prevTabId = 0;
                for (let i = 0; i < tabs.length; i += 1) {
                    if (tabs[i].id === tabId) {
                        if (tabs[i - 1]) {
                            prevTabId = tabs[i - 1].id;
                            that.tabClick(prevTabId);
                        }
                        return;
                    }
                }
            }
        }

        that.props.TransactionStore.setSwipeX(0);
        that.props.TransactionStore.setIsSwipe(false);
    }

    checkSmVersion = () => {
        this.props.VersionStore.check().then(resp => {
            if (!resp) {
                const { activeTemplate } = this.props.templateStore;
                const { data: webSettting } = this.props.webSettingStore;

                confirmAlert(
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                            color: activeTemplate.templateSetting.label.color,
                            fontSize: activeTemplate.templateSetting.label.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                        }}>
                        <span>Info</span>
                    </div>,
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                            color: activeTemplate.templateSetting.text.color, fontSize: activeTemplate.templateSetting.text.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`, textAlign: 'center'
                        }}>
                        <span>New version has been released. Please refresh the page.</span>
                    </div>, [
                    {
                        text:
                            <span
                                style={{
                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                    color: activeTemplate.templateSetting.label.color,
                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                }}
                            >
                                {webSettting.okText}
                            </span>,
                        onPress: () => {
                            window.location.reload(true);
                        }
                    }
                ]);
            }
        });
    }

    render() {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        const showHeaderFooter = localStorage.getItem('showHeaderFooter');

        const {
            activeTabId,
            tabs,
            totalPrice
        } = this.props.TransactionStore;

        let itemIndex = 0;

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            <Layout className='stm-layout'>
                                <IdleTimer ref={ref => { this.idleTimer = ref }} timeout={1000 * 5} onIdle={this.checkSmVersion} debounce={250} />
                                <>
                                    {
                                        webSettting
                                            ?
                                            <>
                                                <Content>
                                                    <Row
                                                        className={showHeaderFooter === 'true' ? 'stm-margin-top-50 stm-width-100-percent' : 'stm-width-100-percent'}
                                                        style={{
                                                            background: `url(${OrderBackground})`
                                                        }}
                                                    >
                                                        <Col span={24}>
                                                            <Row>
                                                                <Col
                                                                    span={24}
                                                                    className='stm-margin-top-24 stm-margin-bottom-24 stm-text-align-center'
                                                                    style={{
                                                                        fontFamily: activeTemplate.templateSetting.tab.fontFamily,
                                                                        color: activeTemplate.templateSetting.tab.color,
                                                                        fontSize: activeTemplate.templateSetting.tab.fontSize,
                                                                        lineHeight: `${activeTemplate.templateSetting.tab.fontSize + 2}px`
                                                                    }}
                                                                >
                                                                    <span>Total: {webSettting.currencyCode} {Format.Currency(totalPrice)}</span>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col span={24}>
                                                            <Tabs
                                                                activeKey={activeTabId}
                                                                className='stm-tab'
                                                                type='line'
                                                                onTabClick={this.tabClick}
                                                                style={{
                                                                    fontFamily: activeTemplate.templateSetting.tab.fontFamily,
                                                                    color: activeTemplate.templateSetting.tab.color,
                                                                    fontSize: activeTemplate.templateSetting.tab.fontSize,
                                                                    lineHeight: `${activeTemplate.templateSetting.tab.fontSize + 2}px`
                                                                }}
                                                            >
                                                                {
                                                                    tabs.map(tab => {
                                                                        let tabName = '';
                                                                        switch (tab.id) {
                                                                            case 1:
                                                                                tabName = webSettting.requestText;
                                                                                break;

                                                                            case 2:
                                                                                tabName = webSettting.inProgressText;
                                                                                break;

                                                                            case 3:
                                                                                tabName = webSettting.reservedText;
                                                                                break;

                                                                            case 4:
                                                                                tabName = webSettting.scheduleText;
                                                                                break;

                                                                            default:
                                                                                tabName = '';
                                                                                break;
                                                                        }
                                                                        return (
                                                                            <TabPane tab={tabName} key={tab.id}>
                                                                                <div
                                                                                    onTouchStart={(e) => this._onTouchStart(e, this)}
                                                                                    onTouchMove={(e) => this._onTouchMove(e, this)}
                                                                                    onTouchEnd={(e) => this._onTouchEnd(e, this, tab.id)}
                                                                                >
                                                                                    <Row className='stm-layout'>
                                                                                        <Col span={1} />
                                                                                        <Col span={22} className='stm-order-container'>
                                                                                            {
                                                                                                tab.items.length === 0
                                                                                                    ?
                                                                                                    <>
                                                                                                        <Row className='stm-order-nodata' key={itemIndex++}>
                                                                                                            <Col
                                                                                                                span={24}
                                                                                                                className='stm-text-align-center'
                                                                                                                style={{
                                                                                                                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                                                    color: activeTemplate.templateSetting.text.color,
                                                                                                                    fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                                                                    lineHeight: `${activeTemplate.templateSetting.text.fontSize + 2}px`
                                                                                                                }}
                                                                                                            >
                                                                                                                <span>{webSettting.noOrderFoundText}</span>
                                                                                                            </Col>
                                                                                                        </Row>
                                                                                                    </>
                                                                                                    :
                                                                                                    <>
                                                                                                        {
                                                                                                            tab.items.map(item => {
                                                                                                                return (
                                                                                                                    <Row
                                                                                                                        className='stm-order-item'
                                                                                                                        key={itemIndex++}
                                                                                                                        onClick={() => this.orderClick(item)}
                                                                                                                    >
                                                                                                                        <Col span={4} className='stm-text-align-center'>
                                                                                                                            {this.showImageOnRender(item)}
                                                                                                                        </Col>
                                                                                                                        <Col
                                                                                                                            span={14}
                                                                                                                            className='stm-padding-left-8'
                                                                                                                        >
                                                                                                                            {
                                                                                                                                item.quantity < 2
                                                                                                                                    ?
                                                                                                                                    <span
                                                                                                                                        style={{
                                                                                                                                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                                                                                                            color: activeTemplate.templateSetting.label.color,
                                                                                                                                            fontSize: activeTemplate.templateSetting.label.fontSize,
                                                                                                                                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                                                                                                        }}
                                                                                                                                    >{item.taskName}</span>
                                                                                                                                    :
                                                                                                                                    <span
                                                                                                                                        style={{
                                                                                                                                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                                                                                                            color: activeTemplate.templateSetting.label.color,
                                                                                                                                            fontSize: activeTemplate.templateSetting.label.fontSize,
                                                                                                                                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                                                                                                        }}
                                                                                                                                    >{`${item.taskName} x${item.quantity}`}</span>
                                                                                                                            }
                                                                                                                            <br />
                                                                                                                            <span
                                                                                                                                style={{
                                                                                                                                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                                                                    color: activeTemplate.templateSetting.text.color,
                                                                                                                                    fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                                                                                    lineHeight: `${activeTemplate.templateSetting.text.fontSize + 12}px`
                                                                                                                                }}
                                                                                                                            >Created at: {item.creationTime}</span>
                                                                                                                        </Col>
                                                                                                                        <Col
                                                                                                                            span={6}
                                                                                                                            className='stm-text-align-right'
                                                                                                                            style={{
                                                                                                                                fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                                                                color: activeTemplate.templateSetting.text.color,
                                                                                                                                fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                                                                                lineHeight: `${activeTemplate.templateSetting.text.fontSize + 2}px`
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            {
                                                                                                                                item.amount === 0
                                                                                                                                    ?
                                                                                                                                    <span>-/-</span>
                                                                                                                                    :
                                                                                                                                    <span>{webSettting.currencyCode} {Format.Currency(item.amount)}</span>
                                                                                                                            }
                                                                                                                        </Col>
                                                                                                                    </Row>
                                                                                                                )
                                                                                                            })
                                                                                                        }
                                                                                                    </>
                                                                                            }
                                                                                        </Col>
                                                                                        <Col span={1} />
                                                                                    </Row>
                                                                                </div>
                                                                            </TabPane>
                                                                        )
                                                                    })
                                                                }
                                                            </Tabs>
                                                        </Col>
                                                    </Row>
                                                </Content>
                                            </>
                                            :
                                            null
                                    }
                                </>
                            </Layout>
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation()(OrderPage)